import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
interface Props {
  title: string;
  crumbs: string[];
  description?: string;
  actions?: React.ReactNode;
}
export function PageHeader({
  title,
  crumbs,
  description,
  actions
}: Props) {
  return <div className="mb-5 flex flex-wrap items-end justify-between gap-3" data-id="element-268" data-mp="12lep98pakoo5">
      <div data-id="element-269" data-mp="xljxl2xozv21">
        <nav aria-label="ব্রেডক্রাম্ব" className="mb-1 flex items-center gap-1 text-xs text-ink-muted" data-id="element-270" data-mp="xl0rqklbgx4d">
          {['ড্যাশবোর্ড', ...crumbs].map((c, i, arr) => <React.Fragment key={c + i} data-id="element-271" data-mp="4wd3cg59trml" data-mpi={i}>
              <span className={i === arr.length - 1 ? 'font-semibold text-navy' : ''} data-id="element-272" data-mp="4xefkny0wk5w">{c}</span>
              {i < arr.length - 1 && <ChevronRightIcon className="h-3 w-3" data-id="element-273" data-mp="jqhne3ltbjjf" />}
            </React.Fragment>)}
        </nav>
        <h1 className="text-2xl font-bold text-ink" data-id="element-274" data-mp="1v7ziyft8pcuv">{title}</h1>
        {description && <p className="mt-0.5 text-sm text-ink-muted" data-id="element-275" data-mp="1va3qd7qcktzw">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2" data-id="element-276" data-mp="1qb0lpoea4psg">{actions}</div>}
    </div>;
}
export function GuardedButton({
  allowed,
  className,
  onClick,
  children,
  reason,
  disabled
}: {
  allowed: boolean;
  className: string;
  onClick: () => void;
  children: React.ReactNode;
  reason?: string;
  disabled?: boolean;
}) {
  return <button className={className} onClick={onClick} disabled={!allowed || disabled} title={!allowed ? reason ?? 'এই কার্যক্রম আপনার ভূমিকায় অনুমোদিত নয়' : undefined} data-id="element-277" data-mp="2jsowqswjin8d">
      {children}
    </button>;
}